import { ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵdefineComponent, ɵɵelementStart, ɵɵtext, ɵɵelementEnd, Component, ɵɵinject, ɵɵelement, ɵɵproperty, ɵɵnextContext, ɵɵadvance, ɵɵtextInterpolate1, ɵɵdirectiveInject, ɵɵlistener, ɵɵtemplate, ɵɵsanitizeUrl, ɵɵtextInterpolate, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { FormGroup, FormControl, Validators, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, DefaultValueAccessor, NgControlStatus, FormControlName, NgForm, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RestService, EnvironmentService, FormValidationService, loaderserice, alertserice } from 'service-common';
import { HttpHeaders, HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateService, TranslateDirective, TranslateModule } from '@ngx-translate/core';
import { Router, RouterLinkWithHref, ActivatedRoute, RouterModule } from '@angular/router';
import { NgIf, CommonModule } from '@angular/common';

class ServiceGuestService {
    constructor() { }
}
ServiceGuestService.ɵfac = function ServiceGuestService_Factory(t) { return new (t || ServiceGuestService)(); };
ServiceGuestService.ɵprov = ɵɵdefineInjectable({ token: ServiceGuestService, factory: ServiceGuestService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ServiceGuestService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class ServiceGuestComponent {
    constructor() { }
    ngOnInit() {
    }
}
ServiceGuestComponent.ɵfac = function ServiceGuestComponent_Factory(t) { return new (t || ServiceGuestComponent)(); };
ServiceGuestComponent.ɵcmp = ɵɵdefineComponent({ type: ServiceGuestComponent, selectors: [["lib-service-guest"]], decls: 2, vars: 0, template: function ServiceGuestComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "p");
        ɵɵtext(1, " service-guest works! ");
        ɵɵelementEnd();
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ServiceGuestComponent, [{
        type: Component,
        args: [{
                selector: 'lib-service-guest',
                template: `
    <p>
      service-guest works!
    </p>
  `,
                styles: []
            }]
    }], function () { return []; }, null); })();

class GuestModel {
}

class GuestService extends RestService {
    constructor(http, env) {
        super(http);
        this.http = http;
        this.env = env;
    }
    login(data) {
        var url = this.env.ApiGateway + "/Guest/login";
        var header = new HttpHeaders({
            'Content-Type': "application/x-www-form-urlencoded"
        });
        return this.http.post(url, data);
    }
    register(data) {
        var url = this.env.ApiGateway + "/Guest/Register";
        return super.post(url, data);
    }
    verified(userid) {
        var url = this.env.ApiGateway + "/Guest/Verified?UserId=" + userid;
        return super.Get(url);
    }
    getCaptch() {
        var url = this.env.ApiGateway + "/guest/Getcaptcha";
        return super.Get(url);
    }
}
GuestService.ɵfac = function GuestService_Factory(t) { return new (t || GuestService)(ɵɵinject(HttpClient), ɵɵinject(EnvironmentService)); };
GuestService.ɵprov = ɵɵdefineInjectable({ token: GuestService, factory: GuestService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(GuestService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HttpClient }, { type: EnvironmentService }]; }, null); })();

const _c0 = ["class", "login"];
function GuestLoginComponent_label_22_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 24);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.login.username_error");
} }
function GuestLoginComponent_label_23_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 25);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r1.translate.instant(ctx_r1.formgroup.get("username").errors == null ? null : ctx_r1.formgroup.get("username").errors.serverError), " ");
} }
function GuestLoginComponent_label_27_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 24);
} if (rf & 2) {
    ɵɵproperty("translate", "auth.login.password_error");
} }
function GuestLoginComponent_label_28_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 25);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r3.translate.instant(ctx_r3.formgroup.get("password").errors == null ? null : ctx_r3.formgroup.get("password").errors.serverError), " ");
} }
class GuestLoginComponent {
    constructor(environment, loginservice, translate, formvalidationService, loader, router) {
        this.environment = environment;
        this.loginservice = loginservice;
        this.translate = translate;
        this.formvalidationService = formvalidationService;
        this.loader = loader;
        this.router = router;
        this.AppLogo = environment.logoUrl;
        this.AppTitle = environment.appTitle;
        translate.translations;
    }
    ngOnInit() {
        this.item = new GuestModel();
        this.formgroup = new FormGroup({
            username: new FormControl('', Validators.required),
            password: new FormControl('', Validators.required)
        });
    }
    IsFieldValid(form, field) {
        return !form.get(field).valid && form.get(field).dirty;
    }
    submit() {
        if (this.formgroup.valid) {
            this.loader.show(true);
            this.loginservice.login(this.item).subscribe(result => {
                this.loader.show(false);
                this.environment.Authtoken = result.authenticationtoken;
                if (this.environment.returnUrl == "" || this.environment.returnUrl == undefined || this.environment.returnUrl == null) {
                    return this.router.navigateByUrl("/inventory");
                }
                else {
                    return this.router.navigateByUrl(this.environment.returnUrl);
                }
            }, reject => {
                this.loader.show(false);
                try {
                    this.formvalidationService.BindServerErrors(this.formgroup, reject);
                }
                catch (error) {
                    console.log(error);
                }
            });
        }
    }
}
GuestLoginComponent.ɵfac = function GuestLoginComponent_Factory(t) { return new (t || GuestLoginComponent)(ɵɵdirectiveInject(EnvironmentService), ɵɵdirectiveInject(GuestService), ɵɵdirectiveInject(TranslateService), ɵɵdirectiveInject(FormValidationService), ɵɵdirectiveInject(loaderserice), ɵɵdirectiveInject(Router)); };
GuestLoginComponent.ɵcmp = ɵɵdefineComponent({ type: GuestLoginComponent, selectors: [["lib-guest", 8, "login"]], attrs: _c0, decls: 41, vars: 16, consts: [[1, "overlay"], [1, "signin", "d-flex"], [1, "container"], [1, "row"], [1, "col"], [1, "d-flex", "justify-content-between", "signin-header", "align-items-center"], [1, "logo"], ["href", "#"], ["alt", "", "width", "143px", 1, "img-fluid", 3, "src"], ["href", "/home", 1, "login-btn"], [1, "signin-form", 3, "formGroup", "ngSubmit"], [3, "translate"], [1, "form-group", "m-0"], ["for", "username m-0", 3, "translate"], ["formControlName", "username", "name", "username", "type", "text", "id", "username", "placeholder", "", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], ["class", "form-text text-danger", 3, "translate", 4, "ngIf"], ["class", "form-text text-danger", 4, "ngIf"], ["for", "password m-0", 3, "translate"], ["formControlName", "password", "name", "password", "type", "password", "id", "password", "placeholder", "", 1, "form-control", 3, "ngModel", "ngModelChange"], ["href", "#", 1, "form-text", "text-white", "text-right", "fogpass", 3, "translate"], [1, "d-flex", "justify-content-between", "signin-btn"], ["type", "submit", 1, "signin-btn", 3, "translate"], [1, "row", "noaccount"], ["routerLink", "/guest/register", 3, "translate"], [1, "form-text", "text-danger", 3, "translate"], [1, "form-text", "text-danger"]], template: function GuestLoginComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "section", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "div", 3);
        ɵɵelementStart(4, "div", 4);
        ɵɵelementStart(5, "div", 5);
        ɵɵelementStart(6, "div", 6);
        ɵɵelementStart(7, "a", 7);
        ɵɵelement(8, "img", 8);
        ɵɵelementStart(9, "p");
        ɵɵelementStart(10, "small");
        ɵɵtext(11);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(12, "a", 9);
        ɵɵtext(13, "Visit Website");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(14, "div", 3);
        ɵɵelementStart(15, "div", 4);
        ɵɵelementStart(16, "form", 10);
        ɵɵlistener("ngSubmit", function GuestLoginComponent_Template_form_ngSubmit_16_listener() { return ctx.submit(); });
        ɵɵelementStart(17, "h4", 11);
        ɵɵtext(18, "SIGN IN");
        ɵɵelementEnd();
        ɵɵelementStart(19, "div", 12);
        ɵɵelement(20, "label", 13);
        ɵɵelementStart(21, "input", 14);
        ɵɵlistener("ngModelChange", function GuestLoginComponent_Template_input_ngModelChange_21_listener($event) { return ctx.item.username = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(22, GuestLoginComponent_label_22_Template, 1, 1, "label", 15);
        ɵɵtemplate(23, GuestLoginComponent_label_23_Template, 2, 1, "label", 16);
        ɵɵelementEnd();
        ɵɵelementStart(24, "div", 12);
        ɵɵelement(25, "label", 17);
        ɵɵelementStart(26, "input", 18);
        ɵɵlistener("ngModelChange", function GuestLoginComponent_Template_input_ngModelChange_26_listener($event) { return ctx.item.password = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(27, GuestLoginComponent_label_27_Template, 1, 1, "label", 15);
        ɵɵtemplate(28, GuestLoginComponent_label_28_Template, 2, 1, "label", 16);
        ɵɵelementStart(29, "a", 19);
        ɵɵtext(30, "Forgot Password");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(31, "div", 20);
        ɵɵelementStart(32, "button", 21);
        ɵɵtext(33, "Sign IN");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(34, "div", 22);
        ɵɵelementStart(35, "div", 4);
        ɵɵelementStart(36, "span", 11);
        ɵɵtext(37, "Don't have an account ?");
        ɵɵelementEnd();
        ɵɵelementStart(38, "span");
        ɵɵelementStart(39, "a", 23);
        ɵɵtext(40, "Register Now");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(8);
        ɵɵproperty("src", ctx.AppLogo, ɵɵsanitizeUrl);
        ɵɵadvance(3);
        ɵɵtextInterpolate(ctx.AppTitle);
        ɵɵadvance(5);
        ɵɵproperty("formGroup", ctx.formgroup);
        ɵɵadvance(1);
        ɵɵproperty("translate", "guest.login.title");
        ɵɵadvance(3);
        ɵɵproperty("translate", "guest.login.email");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.username);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("username").errors == null ? null : ctx.formgroup.get("username").errors.required) && ctx.formgroup.get("username").touched);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("username").errors == null ? null : ctx.formgroup.get("username").errors.serverError);
        ɵɵadvance(2);
        ɵɵproperty("translate", "guest.login.password");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.password);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("password").errors == null ? null : ctx.formgroup.get("password").errors.required) && ctx.formgroup.get("password").touched);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("password").errors == null ? null : ctx.formgroup.get("password").errors.serverError);
        ɵɵadvance(1);
        ɵɵproperty("translate", "auth.login.forgotpassword");
        ɵɵadvance(3);
        ɵɵproperty("translate", "guest.login.signin");
        ɵɵadvance(4);
        ɵɵproperty("translate", "guest.login.donthaveaccount");
        ɵɵadvance(3);
        ɵɵproperty("translate", "guest.login.registernow");
    } }, directives: [ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, TranslateDirective, DefaultValueAccessor, NgControlStatus, FormControlName, NgIf, RouterLinkWithHref], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(GuestLoginComponent, [{
        type: Component,
        args: [{
                selector: 'lib-guest.login',
                templateUrl: './guest.login.component.html',
                styleUrls: ['./guest.login.component.css']
            }]
    }], function () { return [{ type: EnvironmentService }, { type: GuestService }, { type: TranslateService }, { type: FormValidationService }, { type: loaderserice }, { type: Router }]; }, null); })();

class GuestActivationComponent {
    constructor(environment, loginservice, router, alertService, route, loader) {
        this.environment = environment;
        this.loginservice = loginservice;
        this.router = router;
        this.alertService = alertService;
        this.route = route;
        this.loader = loader;
        this.AppLogo = environment.logoUrl;
        this.AppTitle = environment.appTitle;
    }
    ngOnInit() {
        this.route
            .queryParams
            .subscribe(params => {
            try {
                var UserId = params['UserId'];
                if (UserId == undefined)
                    return;
                this.loader.show(true);
                this.loginservice.verified(UserId).subscribe(result => {
                    this.loader.show(false);
                }, error => {
                    this.loader.show(false);
                    this.alertService.Error("Error", "something went wrong");
                });
            }
            catch (error) {
                // this._alertserice.Error("Notification", error); this.loader.show(false);
            }
        });
    }
}
GuestActivationComponent.ɵfac = function GuestActivationComponent_Factory(t) { return new (t || GuestActivationComponent)(ɵɵdirectiveInject(EnvironmentService), ɵɵdirectiveInject(GuestService), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(alertserice), ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(loaderserice)); };
GuestActivationComponent.ɵcmp = ɵɵdefineComponent({ type: GuestActivationComponent, selectors: [["lib-guest-activation"]], decls: 23, vars: 4, consts: [[1, "overlay"], [1, "signin", "d-flex"], [1, "container"], [1, "row"], [1, "col"], [1, "d-flex", "justify-content-between", "signin-header", "align-items-center"], [1, "logo"], ["href", "#"], ["alt", "", "width", "143px", 1, "img-fluid", 3, "src"], ["href", "/home", 1, "login-btn"], [1, "row", "noaccount"], [1, "signin-form"], [3, "translate"], ["routerLink", "/guest/login", 3, "translate"]], template: function GuestActivationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "section", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "div", 3);
        ɵɵelementStart(4, "div", 4);
        ɵɵelementStart(5, "div", 5);
        ɵɵelementStart(6, "div", 6);
        ɵɵelementStart(7, "a", 7);
        ɵɵelement(8, "img", 8);
        ɵɵelementStart(9, "p");
        ɵɵelementStart(10, "small");
        ɵɵtext(11);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(12, "a", 9);
        ɵɵtext(13, "Visit Website");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(14, "div", 3);
        ɵɵelementStart(15, "div", 4);
        ɵɵelementStart(16, "div", 10);
        ɵɵelementStart(17, "div", 4);
        ɵɵelementStart(18, "form", 11);
        ɵɵelementStart(19, "div", 10);
        ɵɵelementStart(20, "span", 12);
        ɵɵtext(21, "Don't have an account ?");
        ɵɵelementEnd();
        ɵɵelement(22, "a", 13);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(8);
        ɵɵproperty("src", ctx.AppLogo, ɵɵsanitizeUrl);
        ɵɵadvance(3);
        ɵɵtextInterpolate(ctx.AppTitle);
        ɵɵadvance(9);
        ɵɵproperty("translate", "guest.activation.message");
        ɵɵadvance(2);
        ɵɵproperty("translate", "guest.activation.signin");
    } }, directives: [ɵangular_packages_forms_forms_y, NgControlStatusGroup, NgForm, TranslateDirective, RouterLinkWithHref], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(GuestActivationComponent, [{
        type: Component,
        args: [{
                selector: 'lib-guest-activation',
                templateUrl: './guest-activation.component.html',
                styleUrls: ['./guest-activation.component.css']
            }]
    }], function () { return [{ type: EnvironmentService }, { type: GuestService }, { type: Router }, { type: alertserice }, { type: ActivatedRoute }, { type: loaderserice }]; }, null); })();

class GuestRegisterModel {
}

function RegisterComponent_label_22_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 30);
} if (rf & 2) {
    ɵɵproperty("translate", "guest.register.name_error");
} }
function RegisterComponent_label_23_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 31);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r1.translate.instant(ctx_r1.formgroup.get("name").errors == null ? null : ctx_r1.formgroup.get("name").errors.serverError), " ");
} }
function RegisterComponent_label_27_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 30);
} if (rf & 2) {
    ɵɵproperty("translate", "guest.register.email_error");
} }
function RegisterComponent_label_28_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 30);
} if (rf & 2) {
    ɵɵproperty("translate", "guest.register.email_format_error");
} }
function RegisterComponent_label_29_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 31);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r4.translate.instant(ctx_r4.formgroup.get("email").errors == null ? null : ctx_r4.formgroup.get("email").errors.serverError), " ");
} }
function RegisterComponent_label_33_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 30);
} if (rf & 2) {
    ɵɵproperty("translate", "guest.register.phoneNo_error");
} }
function RegisterComponent_label_34_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 31);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r6.translate.instant(ctx_r6.formgroup.get("phoneNo").errors == null ? null : ctx_r6.formgroup.get("phoneNo").errors.serverError), " ");
} }
function RegisterComponent_label_38_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 30);
} if (rf & 2) {
    ɵɵproperty("translate", "guest.register.password_error");
} }
function RegisterComponent_label_39_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 31);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r8.translate.instant(ctx_r8.formgroup.get("password").errors == null ? null : ctx_r8.formgroup.get("password").errors.serverError), " ");
} }
function RegisterComponent_label_43_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 30);
} if (rf & 2) {
    ɵɵproperty("translate", "guest.register.confirmPassword_error");
} }
function RegisterComponent_label_44_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 30);
} if (rf & 2) {
    ɵɵproperty("translate", "guest.register.confirmPassword_matche_error");
} }
function RegisterComponent_label_45_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 31);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r11.translate.instant(ctx_r11.formgroup.get("confirmPassword").errors == null ? null : ctx_r11.formgroup.get("confirmPassword").errors.serverError), " ");
} }
function RegisterComponent_label_54_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 30);
} if (rf & 2) {
    ɵɵproperty("translate", "guest.register.captchCode_error");
} }
function RegisterComponent_label_55_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "label", 31);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r13.translate.instant(ctx_r13.formgroup.get("captchCode").errors == null ? null : ctx_r13.formgroup.get("captchCode").errors.serverError), " ");
} }
class RegisterComponent {
    constructor(environment, loginservice, translate, formvalidationService, loader, router, alertService) {
        this.environment = environment;
        this.loginservice = loginservice;
        this.translate = translate;
        this.formvalidationService = formvalidationService;
        this.loader = loader;
        this.router = router;
        this.alertService = alertService;
        this.submited = false;
        this.AppLogo = environment.logoUrl;
        this.AppTitle = environment.appTitle;
        translate.translations;
    }
    ngOnInit() {
        this.item = new GuestRegisterModel();
        this.formgroup = new FormGroup({
            name: new FormControl('', Validators.required),
            email: new FormControl('', Validators.compose([Validators.required, Validators.email])),
            phoneNo: new FormControl('', Validators.compose([Validators.required])),
            password: new FormControl('', Validators.required),
            confirmPassword: new FormControl('', Validators.compose([Validators.required])),
            captchCode: new FormControl('', Validators.required)
        });
        this.refreshCaptch();
    }
    submit() {
        this.submited = true;
        if (this.formgroup.valid) {
            this.loader.show(true);
            this.loginservice.register(this.item).subscribe(result => {
                this.loader.show(false);
                if (result.status) {
                    this.alertService.success("Success", this.translate.instant(result.meesage));
                    this.formgroup.reset();
                }
                else {
                    this.alertService.Error("Error", this.translate.instant(result.meesage));
                }
            }, reject => {
                this.loader.show(false);
                this.alertService.Error("Error", "something went wrong");
                try {
                    this.formvalidationService.BindServerErrors(this.formgroup, reject.error);
                }
                catch (error) {
                    console.log(error);
                }
            });
        }
    }
    refreshCaptch() {
        this.loginservice.getCaptch().subscribe(result => {
            this.captchaImg = result.imgpath;
        });
    }
}
RegisterComponent.ɵfac = function RegisterComponent_Factory(t) { return new (t || RegisterComponent)(ɵɵdirectiveInject(EnvironmentService), ɵɵdirectiveInject(GuestService), ɵɵdirectiveInject(TranslateService), ɵɵdirectiveInject(FormValidationService), ɵɵdirectiveInject(loaderserice), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(alertserice)); };
RegisterComponent.ɵcmp = ɵɵdefineComponent({ type: RegisterComponent, selectors: [["lib-register"]], decls: 60, vars: 32, consts: [[1, "overlay"], [1, "signin", "d-flex"], [1, "container"], [1, "row"], [1, "col"], [1, "d-flex", "justify-content-between", "signin-header", "align-items-center"], [1, "logo"], ["href", "#"], ["alt", "", "width", "143px", 1, "img-fluid", 3, "src"], ["routerLink", "/guest/login", 1, "login-btn"], [1, "signin-form", 3, "formGroup", "ngSubmit"], [3, "translate"], [1, "form-group", "m-0"], ["for", "username m-0", 3, "translate"], ["formControlName", "name", "name", "name", "type", "text", "id", "name", "placeholder", "", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], ["class", "form-text text-danger", 3, "translate", 4, "ngIf"], ["class", "form-text text-danger", 4, "ngIf"], ["formControlName", "email", "name", "email", "type", "text", "id", "email", "placeholder", "", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], ["formControlName", "phoneNo", "name", "phoneNo", "type", "text", "id", "phoneNo", "placeholder", "", "aria-describedby", "emailHelp", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "password m-0", 3, "translate"], ["formControlName", "password", "name", "password", "type", "password", "id", "password", "placeholder", "", 1, "form-control", 3, "ngModel", "ngModelChange"], ["formControlName", "confirmPassword", "name", "confirmPassword", "type", "password", "id", "confirmPassword", "placeholder", "", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "captchCode m-0", 3, "translate"], [2, "margin-left", "5px", 3, "src"], [1, "input-group"], [1, "input-group-prepend"], ["type", "button", "id", "button-addon1", "wfd-id", "1448", 1, "btn", "btn-outline-secondary", 3, "click"], ["formControlName", "captchCode", "name", "captchCode", "type", "text", "id", "captchCode", "placeholder", "", 1, "form-control", 3, "ngModel", "ngModelChange"], [1, "d-flex", "justify-content-between", "signin-btn"], ["type", "submit", 1, "signin-btn", 3, "translate"], [1, "form-text", "text-danger", 3, "translate"], [1, "form-text", "text-danger"]], template: function RegisterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "section", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "div", 3);
        ɵɵelementStart(4, "div", 4);
        ɵɵelementStart(5, "div", 5);
        ɵɵelementStart(6, "div", 6);
        ɵɵelementStart(7, "a", 7);
        ɵɵelement(8, "img", 8);
        ɵɵelementStart(9, "p");
        ɵɵelementStart(10, "small");
        ɵɵtext(11);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(12, "a", 9);
        ɵɵtext(13, "Login");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(14, "div", 3);
        ɵɵelementStart(15, "div", 4);
        ɵɵelementStart(16, "form", 10);
        ɵɵlistener("ngSubmit", function RegisterComponent_Template_form_ngSubmit_16_listener() { return ctx.submit(); });
        ɵɵelementStart(17, "h4", 11);
        ɵɵtext(18, "GEUST SIGN UP");
        ɵɵelementEnd();
        ɵɵelementStart(19, "div", 12);
        ɵɵelement(20, "label", 13);
        ɵɵelementStart(21, "input", 14);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_21_listener($event) { return ctx.item.name = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(22, RegisterComponent_label_22_Template, 1, 1, "label", 15);
        ɵɵtemplate(23, RegisterComponent_label_23_Template, 2, 1, "label", 16);
        ɵɵelementEnd();
        ɵɵelementStart(24, "div", 12);
        ɵɵelement(25, "label", 13);
        ɵɵelementStart(26, "input", 17);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_26_listener($event) { return ctx.item.email = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(27, RegisterComponent_label_27_Template, 1, 1, "label", 15);
        ɵɵtemplate(28, RegisterComponent_label_28_Template, 1, 1, "label", 15);
        ɵɵtemplate(29, RegisterComponent_label_29_Template, 2, 1, "label", 16);
        ɵɵelementEnd();
        ɵɵelementStart(30, "div", 12);
        ɵɵelement(31, "label", 13);
        ɵɵelementStart(32, "input", 18);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_32_listener($event) { return ctx.item.phoneNo = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(33, RegisterComponent_label_33_Template, 1, 1, "label", 15);
        ɵɵtemplate(34, RegisterComponent_label_34_Template, 2, 1, "label", 16);
        ɵɵelementEnd();
        ɵɵelementStart(35, "div", 12);
        ɵɵelement(36, "label", 19);
        ɵɵelementStart(37, "input", 20);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_37_listener($event) { return ctx.item.password = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(38, RegisterComponent_label_38_Template, 1, 1, "label", 15);
        ɵɵtemplate(39, RegisterComponent_label_39_Template, 2, 1, "label", 16);
        ɵɵelementEnd();
        ɵɵelementStart(40, "div", 12);
        ɵɵelement(41, "label", 19);
        ɵɵelementStart(42, "input", 21);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_42_listener($event) { return ctx.item.confirmPassword = $event; });
        ɵɵelementEnd();
        ɵɵtemplate(43, RegisterComponent_label_43_Template, 1, 1, "label", 15);
        ɵɵtemplate(44, RegisterComponent_label_44_Template, 1, 1, "label", 15);
        ɵɵtemplate(45, RegisterComponent_label_45_Template, 2, 1, "label", 16);
        ɵɵelementEnd();
        ɵɵelementStart(46, "div", 12);
        ɵɵelement(47, "label", 22);
        ɵɵelement(48, "img", 23);
        ɵɵelementStart(49, "div", 24);
        ɵɵelementStart(50, "div", 25);
        ɵɵelementStart(51, "button", 26);
        ɵɵlistener("click", function RegisterComponent_Template_button_click_51_listener() { return ctx.refreshCaptch(); });
        ɵɵtext(52, "Refresh");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(53, "input", 27);
        ɵɵlistener("ngModelChange", function RegisterComponent_Template_input_ngModelChange_53_listener($event) { return ctx.item.captchCode = $event; });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(54, RegisterComponent_label_54_Template, 1, 1, "label", 15);
        ɵɵtemplate(55, RegisterComponent_label_55_Template, 2, 1, "label", 16);
        ɵɵelementEnd();
        ɵɵelementStart(56, "div", 12);
        ɵɵelementStart(57, "div", 28);
        ɵɵelementStart(58, "button", 29);
        ɵɵtext(59, "Submit");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(8);
        ɵɵproperty("src", ctx.AppLogo, ɵɵsanitizeUrl);
        ɵɵadvance(3);
        ɵɵtextInterpolate(ctx.AppTitle);
        ɵɵadvance(5);
        ɵɵproperty("formGroup", ctx.formgroup);
        ɵɵadvance(1);
        ɵɵproperty("translate", "guest.register.title");
        ɵɵadvance(3);
        ɵɵproperty("translate", "guest.register.name");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.name);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("name").errors == null ? null : ctx.formgroup.get("name").errors.required) && (ctx.submited || ctx.formgroup.get("name").touched));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("name").errors == null ? null : ctx.formgroup.get("name").errors.serverError);
        ɵɵadvance(2);
        ɵɵproperty("translate", "guest.register.email");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.email);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("email").errors == null ? null : ctx.formgroup.get("email").errors.required) && (ctx.submited || ctx.formgroup.get("email").touched));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("email").errors == null ? null : ctx.formgroup.get("email").errors.email) && (ctx.submited || ctx.formgroup.get("email").touched));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("email").errors == null ? null : ctx.formgroup.get("email").errors.serverError);
        ɵɵadvance(2);
        ɵɵproperty("translate", "guest.register.phoneNo");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.phoneNo);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("phoneNo").errors == null ? null : ctx.formgroup.get("phoneNo").errors.required) && (ctx.submited || ctx.formgroup.get("phoneNo").touched));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("phoneNo").errors == null ? null : ctx.formgroup.get("phoneNo").errors.serverError);
        ɵɵadvance(2);
        ɵɵproperty("translate", "guest.register.password");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.password);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("password").errors == null ? null : ctx.formgroup.get("password").errors.required) && (ctx.submited || ctx.formgroup.get("password").touched));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("password").errors == null ? null : ctx.formgroup.get("password").errors.serverError);
        ɵɵadvance(2);
        ɵɵproperty("translate", "guest.register.confirmPassword");
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.item.confirmPassword);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("confirmPassword").errors == null ? null : ctx.formgroup.get("confirmPassword").errors.required) && (ctx.submited || ctx.formgroup.get("confirmPassword").touched));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !(ctx.formgroup.get("confirmPassword").errors == null ? null : ctx.formgroup.get("confirmPassword").errors.required) && ctx.item.password != ctx.item.confirmPassword && ctx.formgroup.get("confirmPassword").touched);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("confirmPassword").errors == null ? null : ctx.formgroup.get("confirmPassword").errors.serverError);
        ɵɵadvance(2);
        ɵɵproperty("translate", "guest.register.captchCode");
        ɵɵadvance(1);
        ɵɵproperty("src", ctx.captchaImg, ɵɵsanitizeUrl);
        ɵɵadvance(5);
        ɵɵproperty("ngModel", ctx.item.captchCode);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.formgroup.get("captchCode").errors == null ? null : ctx.formgroup.get("captchCode").errors.required) && (ctx.submited || ctx.formgroup.get("captchCode").touched));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.formgroup.get("captchCode").errors == null ? null : ctx.formgroup.get("captchCode").errors.serverError);
        ɵɵadvance(3);
        ɵɵproperty("translate", "guest.register.signup");
    } }, directives: [RouterLinkWithHref, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, TranslateDirective, DefaultValueAccessor, NgControlStatus, FormControlName, NgIf], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(RegisterComponent, [{
        type: Component,
        args: [{
                selector: 'lib-register',
                templateUrl: './register.component.html',
                styleUrls: ['./register.component.css']
            }]
    }], function () { return [{ type: EnvironmentService }, { type: GuestService }, { type: TranslateService }, { type: FormValidationService }, { type: loaderserice }, { type: Router }, { type: alertserice }]; }, null); })();

const routes = [
    {
        path: "",
        redirectTo: "login",
        pathMatch: "full"
    },
    {
        path: 'login',
        component: GuestLoginComponent
    },
    {
        path: 'register',
        component: RegisterComponent
    },
    {
        path: 'Activation',
        component: GuestActivationComponent
    }
];
class ServiceGuestRoutingModule {
}
ServiceGuestRoutingModule.ɵmod = ɵɵdefineNgModule({ type: ServiceGuestRoutingModule });
ServiceGuestRoutingModule.ɵinj = ɵɵdefineInjector({ factory: function ServiceGuestRoutingModule_Factory(t) { return new (t || ServiceGuestRoutingModule)(); }, imports: [[RouterModule.forChild(routes)],
        RouterModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(ServiceGuestRoutingModule, { imports: [RouterModule], exports: [RouterModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(ServiceGuestRoutingModule, [{
        type: NgModule,
        args: [{
                imports: [RouterModule.forChild(routes)],
                exports: [RouterModule]
            }]
    }], null, null); })();

class ServiceGuestModule {
    static forRoot() {
        return {
            ngModule: ServiceGuestModule,
            providers: [
                GuestService
            ]
        };
    }
}
ServiceGuestModule.ɵmod = ɵɵdefineNgModule({ type: ServiceGuestModule });
ServiceGuestModule.ɵinj = ɵɵdefineInjector({ factory: function ServiceGuestModule_Factory(t) { return new (t || ServiceGuestModule)(); }, imports: [[
            ServiceGuestRoutingModule,
            FormsModule, ReactiveFormsModule,
            TranslateModule.forChild(),
            HttpClientModule,
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(ServiceGuestModule, { declarations: [ServiceGuestComponent, GuestLoginComponent, RegisterComponent, GuestActivationComponent], imports: [ServiceGuestRoutingModule,
        FormsModule, ReactiveFormsModule, TranslateModule, HttpClientModule,
        CommonModule], exports: [ServiceGuestComponent, RegisterComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(ServiceGuestModule, [{
        type: NgModule,
        args: [{
                declarations: [ServiceGuestComponent, GuestLoginComponent, RegisterComponent, GuestActivationComponent],
                imports: [
                    ServiceGuestRoutingModule,
                    FormsModule, ReactiveFormsModule,
                    TranslateModule.forChild(),
                    HttpClientModule,
                    CommonModule
                ],
                exports: [ServiceGuestComponent, RegisterComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of service-guest
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GuestService, RegisterComponent, ServiceGuestComponent, ServiceGuestModule, ServiceGuestService };
//# sourceMappingURL=service-guest.js.map
